const data = [
  require('./00_click.png'),
  require('./01_click.png'),
  require('./02_click.png'),
  require('./03_click.png'),
  require('./04_click.png'),
  require('./05_click.png'),
  require('./06_click.png'),
  require('./07_click.png'),
  require('./08_click.png'),
];
export default data;
